import _ from "lodash";
import client from "lib/apolloClient/client";
import { getAIConversationsQuery } from "./AnnouncementAssistantQueries";

export const getAIConversationsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getAIConversationsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const writeAIConversationsInCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getAIConversationsQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};
